import { put, call, select, takeLatest } from 'redux-saga/effects';

import api from 'services/api';
import authService from 'services/authService';

import * as SESSION from 'store/session';
import { receiveUser } from 'store/session/actions';

import { submitStripeUpdate } from './actions';
import { types } from './actions';

export default function* root() {
  yield takeLatest(types.SUBMIT_STRIPE_UPDATE_REQUEST, watchStripeUpdate);
}

function* watchStripeUpdate({ payload }) {
  const { onSuccess, onError } = payload;

  try {
    const groupId = yield select(SESSION.selectors.getGroupId);
    yield call(api.payments.patchConnectedAccount, groupId, {
      external_account: payload.token.id,
    });
    const user = yield call(authService.profile);
    yield put(receiveUser(user));
    yield put(submitStripeUpdate.success({ onSuccess }));
  } catch (e) {
    yield put(submitStripeUpdate.error({ onError }));
  }
}
